<template>
    <div class="container">
        <div class="board">
            <div v-bind:key="row" v-for="row in renderBoard" class="board-row">
                <div v-bind:key="cell" v-for="cell in row"
                     class="board-cell" :class="cell.cellStyleClass">
                    <div class="chess-piece no-select"
                         @click="selectCell(cell)"
                         :style="{'height': cellSize, 'width': cellSize}"
                         v-html="cell.svg"
                    >
                    </div>
                    <div v-if="cell.availablePosition"
                         :style="{'height': selectionSize, 'width': selectionSize, 'top': selectionMargin, 'left': selectionMargin}"
                         @click="selectCell(cell)"
                         class="cell-selection">
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom-panel">
            <button class="chess-button no-select" :disabled='undoDisabled' @click="undo">◀</button>
            <button class="chess-button no-select" :disabled='redoDisabled' @click="redo">▶</button>
            <!-- <button @click="showSettings">1</button> -->
        </div>
        <!-- <vue-modaltor
                :visible="settings"
                @hide="settings = false">
        </vue-modaltor> -->
    </div>
</template>

<script>
    import {initGame} from "./gameModes/default";

    export default {
        name: "Chess",
        methods: {
            undo() {
                this.game.board.history.undo();
                this.availablePositions = [];
                this.selectedPiece = null;
            },
            redo() {
                this.game.board.history.redo();
                this.availablePositions = [];
                this.selectedPiece = null;
            },
            selectCell(cell) {
                let newSelection = null;
                let newAvailablePosition = [];
                if (cell.availablePosition && this.selectedPiece) {
                    this.game.board.movePiece(this.selectedPiece, cell.posX, cell.posY);
                } else {
                    const piece = this.game.board.getPiece(cell.posX, cell.posY);
                    if (piece && piece.player === this.game.board.currentPlayer) {
                        newAvailablePosition = piece.availablePositions(this.game.board);
                    }
                    newSelection = piece;
                }
                this.availablePositions = newAvailablePosition;
                this.selectedPiece = newSelection;
            }
        },
        data() {
            return {
                game: initGame(),
                selectedPiece: null,
                availablePositions: [],
                player: 'white',
                settings: false
            }
        },
        computed: {
            renderBoard() {
                const board = [];
                for (let i = this.game.board.scaleY - 1; i >= 0; i--) {
                    const row = [];
                    for (let j = 0; j < this.game.board.scaleX; j++) {
                        const cell = {};
                        cell.posX = j;
                        cell.posY = i;
                        cell.cellStyleClass = "";
                        const piece = this.game.board.chessPieces.find(p => {
                            return p.posX === j && p.posY === i;
                        });
                        if (piece) {
                            if (piece.player === 'black') {
                                cell.svg = piece.svgBlack;
                                if (this.game.settings.rotateTop) {
                                    cell.cellStyleClass += ' flip';
                                }
                            } else {
                                cell.svg = piece.svgWhite;
                            }
                            if (piece === this.selectedPiece && piece.player === this.game.board.currentPlayer) {
                                cell.cellStyleClass += ' piece-selected';
                            }
                        }
                        if (this.availablePositions.find(ap => ap[0] === j && ap[1] === i)) {
                            cell.availablePosition = true;
                        }
                        const previousMove = this.game.board.history.moves[this.game.board.history.currentMove];
                        if (previousMove &&
                            ((previousMove.from[0] === j && previousMove.from[1] === i) ||
                            (previousMove.to[0] === j && previousMove.to[1] === i))) {
                            cell.cellStyleClass += ' piece-move';
                        }
                        row.push(cell);
                    }
                    board.push(row)
                }
                return board;
            },
            cellBaseSize() {
                return Math.floor(100 / Math.max(3, this.game.board.scaleY, this.game.board.scaleX) * 0.9);
            },
            cellBaseUnits() {
                return window.innerHeight > window.innerWidth ? 'vw' : 'vh';
            },
            cellSize() {
                return this.cellBaseSize + this.cellBaseUnits;
            },
            selectionSize() {
                return this.cellBaseSize / 2 + this.cellBaseUnits;
            },
            selectionMargin() {
                return this.cellBaseSize / 4 + this.cellBaseUnits;
            },
            undoDisabled() {
                return !this.game.board.history.canUndo();
            },
            redoDisabled() {
                return !this.game.board.history.canRedo();
            }
        }
    }

</script>

<style scoped>
    .board-row {
        display: flex;
        width: auto;
        clear: both;
    }

    .board-cell {
        float: left;
        width: 100%;
        height: 100%;
        position: relative;
    }

    .board .board-row:nth-child(even) .board-cell:nth-child(odd).piece-move,
    .board .board-row:nth-child(odd) .board-cell:nth-child(even).piece-move {
        background: #d1c17c;
    }

    .board .board-row:nth-child(odd) .board-cell:nth-child(odd).piece-move,
    .board .board-row:nth-child(even) .board-cell:nth-child(even).piece-move {
        background: #ffedb1;
    }

    .board .board-row:nth-child(even) .board-cell:nth-child(odd).piece-selected,
    .board .board-row:nth-child(odd) .board-cell:nth-child(even).piece-selected {
        background: #dba752;
        box-shadow: inset 0 0 0 5px #c28f4e;
    }

    .board .board-row:nth-child(odd) .board-cell:nth-child(odd).piece-selected,
    .board .board-row:nth-child(even) .board-cell:nth-child(even).piece-selected {
        background: #ffdd9a;
        box-shadow: inset 0 0 0 5px #d6aa6c;
    }

    .board .board-row:nth-child(even) .board-cell:nth-child(odd),
    .board .board-row:nth-child(odd) .board-cell:nth-child(even) {
        background: #d18b47;
    }

    .board .board-row:nth-child(odd) .board-cell:nth-child(odd),
    .board .board-row:nth-child(even) .board-cell:nth-child(even) {
        background: #ffce9e;
    }

    .board {
        display: flex;
        flex-direction: column;
    }

    .chess-piece {
        font-family: stchess, serif;
    }

    .container {
        width: 100%;
        display: flex;
        justify-content: center;
        height: 100vh;
        align-items: center;
        flex-direction: column;
    }

    .bottom-panel {
        display: flex;
        flex-direction: row;
    }

    .chess-button {
        font-size: 5vh;
        margin-top: 2vh;
        margin-left: 5vh;
        margin-right: 5vh;
        padding: 0;
        border: none;
        background: none;
    }

    .cell-selection {
        position: absolute;
        width: 5vh;
        height: 5vh;
        -webkit-border-radius: 3vh;
        -moz-border-radius: 3vh;
        border-radius: 3vh;
        background: rgba(241, 255, 225, 0.11);
        box-sizing: border-box;
        border:0.5vh solid #f1ffe1;
        top: 0;
        left: 0;
    }

    .flip {
        -moz-transform: scale(-1, -1);
        -o-transform: scale(-1, -1);
        -webkit-transform: scale(-1, -1);
        transform: scale(-1, -1);
    }

</style>